import { Component, computed, inject, input } from "@angular/core";
import { CreditService } from "@app/shared/payment/services/credit.service";
import { TranslatePipe } from "@ngx-translate/core";
import { NgIf } from "@angular/common";

@Component({
  selector: "app-credit-overview",
  imports: [TranslatePipe, NgIf],
  templateUrl: "./credit-overview.component.html",
  styleUrl: "./credit-overview.component.scss",
})
export class CreditOverviewComponent {
  creditService = inject(CreditService);
  isMobile = input<boolean>(false);

  // Create a computed signal from it
  currentCredit = computed(() => this.creditService.creditDetails()?.totalAvailableCredits ?? 0);

  progressWidth = computed(() => {
    return (this.currentCredit() / (this.creditService.creditDetails()?.subscriptionCreditLimit ?? 10)) * 100;
  });

  willUse = input<number | undefined>(undefined);
  showProgress = input<boolean>(false);
}
